/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ArrowLeft from 'DesignSystem/Svgs/ArrowLeft/index'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCaseCloser/Configuration/DefaultPaymentPlans/AddRuleset/DefaultPaymentPlans/Content/DefaultPaymentPlan/Actions/Down/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 onClick={onClick}
 paddingTop={dtSpaceXxs}
 paddingLeft={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 paddingRight={dtSpaceXxs}
 marginRight={dtSpaceXs}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ArrowLeft
  viewPath={`${viewPath}/ArrowLeft`}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
</div>
)}
</ButtonIcon>
{children}
</React.Fragment>)
}